'use strict'

const state = {}

const getters = {}

const actions = {
  determineCompanyActiveProcess({dispatch, rootGetters}) {
    const currentUerCompany = rootGetters['user/company']
    // determine active process
    const activeProcessName = currentUerCompany &&
      currentUerCompany.meta &&
      currentUerCompany.meta.active_process
      ? currentUerCompany.meta.active_process
      : null

    dispatch('process/setName', activeProcessName, {root: true})
  },
  clearActiveProcess({dispatch}) {
    dispatch('process/setName', null, {root: true})
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
